import classNames from "classnames";
import React, { PropsWithChildren } from "react";

interface FormProps
  extends React.FormHTMLAttributes<HTMLFormElement>,
    PropsWithChildren {
  /** Extra classes to attach for modifying the standard pattern styles*/
  extraClasses?: string;
  /** Optional text used to provide an accessible label for the form*/
  ariaLabel?: string;
  /** If all inputs are required set this to true and it will display a message */
  allRequired?: boolean;
}

export const Form: React.FC<FormProps> = ({
  extraClasses,
  ariaLabel,
  children,
  allRequired = false,
  ...props
}) => {
  const formClasses = classNames("form", {
    [`${extraClasses}`]: extraClasses,
  });

  return (
    <form className={formClasses} aria-label={ariaLabel} {...props}>
      {allRequired && (
        <span className="form__required-message">All fields are required</span>
      )}
      {children}
    </form>
  );
};
